import { createFileRoute } from '@tanstack/react-router';
import { LoginLayout } from '../../layouts/Login/LoginLayout';

export const Route = createFileRoute('/$retailer/')({
  component: LoginLayout,
});
